import script from "./CensusConfirmQuit.vue?vue&type=script&setup=true&lang=js"
export * from "./CensusConfirmQuit.vue?vue&type=script&setup=true&lang=js"

import "./CensusConfirmQuit.vue?vue&type=style&index=0&id=9258ead0&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9258ead0"]])

export default __exports__